import React, { useEffect, useState } from 'react';

import SiteLayout from '../components/SiteLayout';
import { withBreakpoints } from '../components/Boneyard';
import CookiesDisabledMessage from '../components/CookiesDisabledMessage';
import StadiumPage from '../pageComponents/StadiumPage';

const Raiders = () => {
  const [areCookiesEnabled, setAreCookiesEnabled] = useState(undefined);

  useEffect(() => {
    let cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    }
    setAreCookiesEnabled(cookieEnabled);
  }, []);

  // only check cookies on the client side
  if (typeof window !== 'undefined') {
    if (!areCookiesEnabled) {
      return <CookiesDisabledMessage />;
    }
  }

  return (
    <SiteLayout title="Raiders">
      <StadiumPage />
    </SiteLayout>
  );
};

export default withBreakpoints(Raiders);
